import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useNavigate } from 'react-router-dom';
import { FaDownload, FaInfoCircle } from 'react-icons/fa';
import './Hero.css';

const Hero = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const navigate = useNavigate();

  const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { 
      opacity: 1, 
      scale: 1,
      transition: { duration: 0.8, delay: 0.3, ease: "easeOut" }
    }
  };

  const handleDownloadClick = (e) => {
    e.preventDefault();
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const downloadSection = document.getElementById('download');
        if (downloadSection) {
          downloadSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const downloadSection = document.getElementById('download');
      if (downloadSection) {
        downloadSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const featuresSection = document.getElementById('features');
        if (featuresSection) {
          featuresSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const featuresSection = document.getElementById('features');
      if (featuresSection) {
        featuresSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <section className="hero" ref={ref}>
      {/* Background Cover Image */}
      <div className="hero-cover-container">
        <img src="/Cover.png" alt="SyarTech Service" className="cover-image" />
      </div>
      
      <div className="container">
        <div className="hero-content">
          <motion.div 
            className="hero-text"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={textVariants}
          >
            <motion.h1 variants={textVariants}>
              Your Car Deserves the Best Care
            </motion.h1>
            <motion.p variants={textVariants}>
              Book professional car wash services instantly with our app. Experience convenience, quality, and shine like never before.
            </motion.p>
            <motion.div 
              className="hero-buttons"
              variants={textVariants}
            >
              <button onClick={handleDownloadClick} className="btn btn-primary">
                <FaDownload className="btn-icon" />
                Download App
              </button>
              <button onClick={handleLearnMoreClick} className="btn btn-secondary">
                <FaInfoCircle className="btn-icon" />
                Learn More
              </button>
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="hero-image"
            initial="hidden"
            animate={inView ? "visible" : "hidden"}
            variants={imageVariants}
          >
            <div className="phone-mockup">
              <div className="app-screen">
                <div className="app-header">
                  <div className="app-status-bar"></div>
                </div>
                <div className="app-content">
                  <div className="service-card">
                    <h4>Membership: Silver</h4>
                    <p>3 days a week 350 EGP/mo</p>
                  </div>
                  <div className="service-card">
                    <h4>Membership: Gold</h4>
                    <p>4 days a week 450 EGP/mo</p>
                  </div>
                  <div className="service-card">
                    <h4>Platinum service</h4>
                    <p>5 days a week + interior 600 EGP/mo</p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
